import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { ContestService } from 'src/app/services/contest.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WalletpaymentService } from 'src/app/services/walletPayments.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { environment } from 'src/environments/environment';
import { UserContestService } from 'src/app/services/usercontest.service';

@Component({
  selector: 'app-contest-payment-selection-page',
  templateUrl: './contest-payment-selection-page.component.html',
  styleUrls: ['./contest-payment-selection-page.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ContestPaymentSelectionPageComponent implements OnInit {
  contestId: string;
  userId: string;
  totalCash: any;
  totalDeductedCash: any;
  totalAvailableCash: number;
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableContestCash: number;
  entryFee: any = 0;
  minimumAmountToBeAdded: number;
  contestJoinPaymentAmountFormGroup: FormGroup;
  useContestCash: boolean = false;
  useTplCash: boolean = false;
  tplCashOption: number = 0;
  tournamentId: any;
  contestJoinEntryFeeError: boolean = false;
  isResumeContest: boolean = false;
  utilizeContestCashAmount: any;
  utilizeContestCash: boolean = false;
  insufficientContestCash: boolean = false;
;
  maximumContestCashUtilize: any;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private userWalletService: UserWalletService, private messageService: MessageService,
    private contestService: ContestService, private formBuider: FormBuilder, private walletPaymentService: WalletpaymentService, private winRef: WindowRefService,
    private userContestService: UserContestService, private renderer: Renderer2,) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'wallet-add-page');
    this.contestId = this.activatedRoute.snapshot.paramMap.get('contestId');
    this.userId = this.activatedRoute.snapshot.paramMap.get('userId');
    this.isResumeContest = (this.activatedRoute.snapshot.queryParamMap.get("resumeContest") === 'true') ? true : false;

    this.contestJoinPaymentAmountFormGroup = this.formBuider.group({
      utilizeContestCash: new FormControl(false),
      utilizeTplCash:new FormControl(true),
      utilizeContestCashAmount: new FormControl(0),
      utilizeCashAmount: new FormControl(0),
      tplCash: new FormControl(0, [Validators.min(0)])
    });
    this.getContestDetails();
    this.tplCashOptions(0);
    if (this.isResumeContest) {
      this.getUserContestDetails();
    }
    this.loadWalletHistory();
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'wallet-add-page');
  }
  
  getUserContestDetails() {
    let query = `filterByDisable=false&filterByStatus=true&filterByUserId=${this.userId}&filterByContestId=${this.contestId}`;
    this.userContestService.getUserContestList(query).subscribe((data) => {
      if (data.data.items.length > 0) {
        this.utilizeContestCash = data.data.items[0]?.utilizeContestCash;
        this.utilizeContestCashAmount = data.data.items[0]?.utilizeContestCashAmount;
      }
    });
  }

  async getContestDetails() {
    this.contestService.getContestDetails(this.contestId).subscribe((res: any) => {
      this.entryFee = res?.entryFee;
      this.tournamentId = res?.tournamentId;
    },
      err => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update failed', life: 6000 });
      });
  }

  loadWalletHistory() {
    var query =
      "?filterByDisable=false&filterByUserid=" +
      this.userId;
    this.userWalletService.getUserWalletList(query).subscribe((data) => {
      this.totalCash = data.data.totalCash;
      this.totalDeductedCash = data.data.totalDeductedCash;
      this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
      this.totalContestCash = data.data.totalContestCash;
      this.totalDeductedContestCash = data.data.totalDeductedContestCash;
      this.totalAvailableContestCash = this.totalContestCash - this.totalDeductedContestCash;
      if (this.isResumeContest) {
        if (this.utilizeContestCash && (this.totalAvailableContestCash >= this.utilizeContestCashAmount)) {
          this.contestJoinPaymentAmountFormGroup.patchValue({
            utilizeContestCash: this.utilizeContestCash,
            utilizeContestCashAmount: this.utilizeContestCashAmount,
            utilizeCashAmount: !this.utilizeContestCash?this.entryFee:0,
            utilizeTplCash: !this.utilizeContestCash
          })
          this.useContestCash = true;
          this.onEnterContestCash({ value: this.utilizeContestCashAmount });
        } else {
          if (this.totalAvailableCash >= this.entryFee) {
            this.contestJoinPaymentAmountFormGroup.get('utilizeCashAmount').setValue((!this.utilizeContestCash) ? this.entryFee : 0);
          }
          this.minimumAmountToBeAdded = this.entryFee - this.totalAvailableCash;
          this.contestJoinPaymentAmountFormGroup.get('tplCash').setValue((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
          this.tplCashOptions((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
        }
      } else {
        if (this.totalAvailableCash >= this.entryFee) {
          this.contestJoinPaymentAmountFormGroup.get('utilizeCashAmount').setValue((!this.utilizeContestCash) ? this.entryFee : 0);
        }
        this.minimumAmountToBeAdded = this.entryFee - this.totalAvailableCash;
        this.contestJoinPaymentAmountFormGroup.get('tplCash').setValue((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
        this.tplCashOptions((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
      }

      this.maximumContestCashUtilize = (this.totalAvailableContestCash > this.entryFee) ? this.entryFee : this.totalAvailableContestCash;
    },
      (err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update failed', life: 6000 });
      });
  }

  onEnterContestCash(event) {
    this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValidators((event.value === null) ? [Validators.required] : null);
    this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').updateValueAndValidity();
    this.minimumAmountRequiredFunction({ checked: true }, event.value);
  }

  onSelectContestCash(checked, enteredContestCash) {
    if (this.totalAvailableContestCash > this.entryFee) {
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValue((checked) ? this.entryFee : 0);
    } else {
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValue((checked) ? this.totalAvailableContestCash : 0);
    }
    this.contestJoinPaymentAmountFormGroup.get('utilizeTplCash').setValue(!checked)
    this.contestJoinPaymentAmountFormGroup.get('utilizeCashAmount').setValue(!checked ? this.entryFee : 0)
    // In case of resume contest
    if (this.isResumeContest && (this.utilizeContestCashAmount <= this.totalAvailableContestCash)) {
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValue((checked) ? this.utilizeContestCashAmount : 0);
    }
    if (checked &&(this.totalAvailableContestCash >= this.entryFee && this.totalAvailableContestCash>=this.entryFee)) {
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValue((checked) ? this.entryFee : 0);
    }else if(checked && this.totalAvailableContestCash<this.entryFee){
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValue((checked) ? this.totalAvailableContestCash : 0);
      this.insufficientContestCash = true;
    }else{
      this.insufficientContestCash = false;

    }

    this.minimumAmountRequiredFunction(checked, enteredContestCash);
  }

  minimumAmountRequiredFunction(checked, enteredContestCash) {
    if (this.totalAvailableCash >= this.entryFee) {
      this.minimumAmountToBeAdded = this.entryFee - this.totalAvailableCash;
    } else {
      this.minimumAmountToBeAdded = this.entryFee - (((checked) ? (enteredContestCash ?? 0) : 0) + this.totalAvailableCash);
    }

    if (enteredContestCash !== null) {
      if (this.totalAvailableContestCash > this.entryFee) {
        this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValidators((checked) ? [Validators.min(1), Validators.max(this.entryFee)] : null);
      } else {
        this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').setValidators((checked) ? [Validators.min(1), Validators.max(this.totalAvailableContestCash)] : null);
      }
      this.contestJoinPaymentAmountFormGroup.get('utilizeContestCashAmount').updateValueAndValidity();
    }

    this.contestJoinPaymentAmountFormGroup.get('tplCash').setValue((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
    this.tplCashOptions((this.minimumAmountToBeAdded > 0) ? this.minimumAmountToBeAdded : 0);
    this.useContestCash = checked;
  }


  tplCashOptions(event) {
    let amount = 0;
    amount = (event.value !== undefined) ? ((event.value !== null) ? event.value : 0) : event;
    this.useTplCash = (amount !== 0) ? true : false;
    const decimalConvertedAmount = amount / 10;
    const isDecimal = ((decimalConvertedAmount - Math.floor(decimalConvertedAmount)) !== 0);
    this.tplCashOption = (isDecimal) ? (Math.ceil(decimalConvertedAmount) * 10) : (Math.ceil(decimalConvertedAmount + 0.1) * 10);
    if (this.tplCashOption < 0) {
      this.tplCashOption = 0;
    }
  }

  onSelectTplCashOption(tplCash: number) {
    this.contestJoinPaymentAmountFormGroup.get('tplCash').setValue(tplCash);
    this.tplCashOptions(tplCash);
  }

 async submitPaymentAmountDetails() {
    if (this.contestJoinPaymentAmountFormGroup.invalid) {
      return;
    }
    if(this.insufficientContestCash){
      return;
    }

    if (this.contestJoinPaymentAmountFormGroup.value.utilizeContestCashAmount === 0 &&
      (this.contestJoinPaymentAmountFormGroup.value.tplCash === 0 || this.contestJoinPaymentAmountFormGroup.value.tplCash === null) &&
      this.totalAvailableCash >= this.entryFee) {
      window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
      this.addWalletPayment(false);
      setTimeout(() => {
        let currentUrl = "/contest-details/" + this.contestId;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        // setTimeout(() => {
          if (this.isResumeContest) {
            this.router.navigate([currentUrl], { queryParams: { contestJoin: true, tplCoins: false,resumeContest: true  } });
          } else {
            this.router.navigate([currentUrl], { queryParams: { contestJoin: true, tplCoins: true  } });
          }
        // }, 200);
      }, 200);
      return;
    }

    if (this.useContestCash) {
      let totalContestJoiningAmount = this.contestJoinPaymentAmountFormGroup.value.utilizeContestCashAmount + this.contestJoinPaymentAmountFormGroup.value.tplCash;
      this.entryFeeValidator(totalContestJoiningAmount);

      if (this.contestJoinEntryFeeError) {
        return;
      }

      this.addWalletPayment(true);
    } else {
      let totalContestJoiningAmount = this.contestJoinPaymentAmountFormGroup.value.tplCash;
      this.entryFeeValidator(totalContestJoiningAmount);

      if (this.contestJoinEntryFeeError) {
        return;
      }

      this.addWalletPayment(false);
    }

  }

  addWalletPayment(useContestCash) {
    let addCashData = {
      contestId: this.contestId,
      tournamentId: this.tournamentId,
      userId: this.userId,
      amount: this.contestJoinPaymentAmountFormGroup.value.tplCash,
      walletType: "CASH",
      action: "ADD",
      status: true,
      description: "Contest Joined",
      utilizeCash: true,
      utilizeContestCash: false
    }

    if (useContestCash) {
      addCashData['utilizeContestCash'] = true,
      addCashData['utilizeContestCashAmount'] = this.contestJoinPaymentAmountFormGroup.value.utilizeContestCashAmount,
      addCashData['previousAmount'] = this.totalAvailableCash
    } else {
      addCashData['utilizeContestCash'] = false;
      addCashData['utilizeContestCashAmount'] = 0;
    }

    this.walletPaymentService
      .addWalletPayment(addCashData)
      .subscribe((data: any) => {
        if (this.useTplCash) {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.contestJoinPaymentAmountFormGroup.value.tplCash * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            this.contestJoinPaymentAmountFormGroup.reset();
            window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
            setTimeout(() => {
              let currentUrl = "/contest-details/" + this.contestId;
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = "reload";
              // setTimeout(() => {
                this.router.navigate([currentUrl], { queryParams: { contestJoin: true, tplCoins: false } });
              // }, 200);
            }, 200);
            // let verifyPaymentData = {
            //   razorpay_payment_id: response.razorpay_payment_id,
            //   razorpay_order_id: response.razorpay_order_id,
            //   razorpay_signature: response.razorpay_signature,
            //   userId: this.userId,
            //   walletType: "CASH",
            //   amount: this.contestJoinPaymentAmountFormGroup.value.tplCash,
            // };
            //commented below code as verify will be done by webhook
            // call your backend api to verify payment signature & capture transaction
            // this.walletPaymentService.verifyWalletpayment(verifyPaymentData).subscribe(paymentdata => {
            //   //this.showThankyouModal = true;
            //   this.onClickSubmit()
            //   this.showCashBalance = false
            //   // window.location.reload(); //use because of issue with reload.
            //   // this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'Cash Added.', life: 6000 });
            //   // let currentUrl = this.router.url;
            //   // setTimeout(() => {
            //   //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   //     this.router.navigate([currentUrl]);
            //   //   });
            //   // }, 2000);
            // })
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        } else {
          this.contestJoinPaymentAmountFormGroup.reset();
          window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
          this.navigateToContestDetailsPageForPayment();
        }
      }, err => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update failed', life: 6000 });
      });
  }

  navigateToContestDetailsPageForPayment() {
    setTimeout(() => {
      let currentUrl = "/contest-details/" + this.contestId;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      // setTimeout(() => {
        if (this.isResumeContest) {
          this.router.navigate([currentUrl], { queryParams: { contestJoin: true, tplCoins: false, resumeContest: true } });
        } else {
          this.router.navigate([currentUrl], { queryParams: { contestJoin: true, tplCoins: false  } });
        }
      // }, 200);
    }, 0);
  }

  navigateToContestDetailsPage() {
    window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
    setTimeout(() => {
      let currentUrl = "/contest-details/" + this.contestId;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      // setTimeout(() => {
        this.router.navigate([currentUrl], { queryParams: { contestJoin: false, tplCoins: false, resumeContest: true } });
      // }, 200);
    }, 200);
    return;
  }

  entryFeeValidator(totalContestJoiningAmount) {
    if (totalContestJoiningAmount < this.entryFee) {
      this.contestJoinEntryFeeError = true;
      if (this.totalAvailableCash >= this.entryFee) {
        this.contestJoinEntryFeeError = false;
      } else if ((this.totalAvailableCash + totalContestJoiningAmount) >= this.entryFee) {
        this.contestJoinEntryFeeError = false;
      }
    } else {
      this.contestJoinEntryFeeError = false;
    }
  }

}
